import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import AlertSettings from '@views/ManageAccount/Alerts/index';
import ManageAccountLayout from '@views/ManageAccount/ManageAccountLayout';

const messages = defineMessages({
  title: {
    id: 'manageAccount.alerts',
    defaultMessage: 'Alerts',
  },
});

export default function ManageAlertsPage(props: PagePropsWithBreadcrumbs) {
  const { formatMessage } = useIntl();

  return (
    <ManageAccountLayout
      friendlyName={formatMessage(messages.title)}
      pageProps={props}
    >
      {({ user }) => <AlertSettings user={user} />}
    </ManageAccountLayout>
  );
}
